export const environment = {
  production: true,
  meetingServiceRootUrl: 'https://api.vcircle.ng/',
  mediasoupScheme: 'https'
};
